import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm'
import ProjectsSchema from 'schemas/projects.schema.json'
import { addProject, updateProject } from 'utils/ProjectsUtils'
import { useFormContext } from 'hooks/useFormContext'
import SkeletonForm from 'components/Shared/SkeletonForm'

const AddProject = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {

    const formContext = useFormContext();
    const refreshLagTime = 3000;

    useEffect(() => {
        !formContext.schema && formContext.updateSchema(ProjectsSchema)
    })

    if (CRUDType === "INSERT") defaultValues['IsActive'] = true && disabledProperties.push('IsActive')
    // contact specific CRUD functions
    const onSubmit = async (values) => {
        let result
        if (CRUDType === "INSERT") {
            result = await addProject(values)
            setTimeout(callback, refreshLagTime)
        } else if (CRUDType === "UPDATE") {
            result = await updateProject(values, defaultValues)
            setTimeout(callback, refreshLagTime)
        }
        return result
    }
    /* 
    on rare occasions, this component may be reached before the full AppContext is done initializing.
    so this form only renders when there is data in selectedProjectData 
    */
    return formContext.ready ?
        withExtension(DynamicForm, { schema: ProjectsSchema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions: formContext.definitions, refreshLagTime }) :
        <SkeletonForm />

}

AddProject.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

AddProject.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}




export default AddProject
